import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { ProductService } from 'features/products/service/service'

export { ProductService } from 'features/products/service/service'

export function useProductService(): ProductService {
  const client = useApiClient()
  return useMemo(() => new ProductService(client), [client])
}
